import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  featuredJobs,
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  Avatar,
  useMediaQuery,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useLocation, useNavigate } from "react-router-dom";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  _get_JD_list_blog_api,
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
} from "../../DAL/partner/partners";
import PageLoading from "../../components/loader/PageLoading";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import moment from "moment";
import { s3baseUri } from "../../config/config";
import PartnersSkeleton from "../../components/loader/PartnerTypeSkelton";
import CardCarousalSkeleton from "../../components/loader/CradCarousalSkelator";
import SkeletonJObs from "../../components/loader/jbsSkeleton";
import CustomDrawer from "../../components/layouts/CustomDrawer";
import JobsFilter from "./JobsFilter";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function FavouriteJobs() {
  const navigate = useNavigate();
  const { findId, setBreadCrumb, userInfo, isRefresh } = useIds();
  const new_valyues = {
    deleteRecordingId: null,
    deleteDialogOpen: false,
    drawerOpen: false,
    selectedCategory: null,
    image: "",
  };

  const [recordingListState, setRecordingListState] = useState(new_valyues);

  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery("(max-width:600px)");
  const scrollRef = useRef(null); // Reference to the scrollable container
  console.log(categories, "categoriescategoriescategories");
  const [openDetail, setOpenDetail] = useState(false);
  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  const [open, setOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    clientName: "",
    location: "",
    education: "",
    jobType: "",
    experience: "",
    minSalary: "",
    maxSalary: "",
    frequency: "",
    // Date filter fields
    dateFilter: "",
    startDate: "",
    endDate: "",
    last24Hours: false, // default should be false
    start_date: "",
    end_date: "",
    // ...other fields
  });

  const { pathname } = useLocation();
  const [partnersObj, setPartnersObj] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    clientName: null,
    experience_required: null,
    education: null,
    job_type: null,
    salary: null,
    education_required: null,
    location: null,
    jobType: null,
    experience: null,
    minSalary: null,
    maxSalary: null,
    frequency: null,
  });

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const load_more_path = "api/jobs/list?page=0&limit=60";
  console.log(findId, "findIdfindId");
  console.log(partnersObj, "partnersObjpartnersObjpartnersObj");
  let icon = {
    iconBg: "#000080",
  };
  const handleCloseDrawer = () => {
    setRecordingListState((old) => ({ ...old, drawerOpen: false }));
  };
  const handleopenFilterDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      drawerOpen: true,
      selectedCategory: null,
    }));
  };
  // Handle search submission
  // const handleSearch = () => {
  //   setSearchTerm(searchInputValue);
  // };

  // Handle Enter key press
  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     handleSearch();
  //   }
  // };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchInputValue("");
    setSearchTerm("");
  };

  const applyFilters = (e) => {
    if (e) e.preventDefault();

    // Salary range validation
    if (
      filterValues.minSalary &&
      filterValues.maxSalary &&
      Number(filterValues.minSalary) > Number(filterValues.maxSalary)
    ) {
      enqueueSnackbar("Min Salary should not be greater than Max Salary.", {
        variant: "error",
      });
      return;
    }

    // Custom date validation
    if (filterValues.dateFilter === "custom") {
      if (!filterValues.startDate || !filterValues.endDate) {
        enqueueSnackbar(
          "Start Date and End Date are required for custom date filter.",
          { variant: "error" }
        );
        return;
      }
      if (filterValues.endDate < filterValues.startDate) {
        enqueueSnackbar(
          "End Date should be greater than or equal to Start Date.",
          { variant: "error" }
        );
        return;
      }
    }

    let last24Hours = false;
    let startDate = "";
    let endDate = "";
    if (filterValues.dateFilter === "last24hours") {
      last24Hours = true;
    } else if (filterValues.dateFilter === "last3days") {
      startDate = moment().subtract(3, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "last7days") {
      startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "last14days") {
      startDate = moment().subtract(14, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "custom") {
      startDate = filterValues.startDate;
      endDate = filterValues.endDate;
    }

    const filters = {
      search: searchTerm,
      clientName: filterValues.clientName,
      location: filterValues.location,
      education: filterValues.education,
      jobType: filterValues.jobType,
      experience: filterValues.experience,
      minSalary: filterValues.minSalary,
      maxSalary: filterValues.maxSalary,
      frequencySalary: filterValues.frequency,
      created_for: findId,
      // Date filter params for API
      ...(last24Hours ? { last24Hours: true } : {}),
      ...(!last24Hours && startDate ? { startDate } : {}),
      ...(!last24Hours && endDate ? { endDate } : {}),
    };
    console.log(filters, "filtersfiltersfilters");
    fetchCategories(load_more_path, searchTerm, false, findId, filters);
    setFilterDrawerOpen(false);
    // When applying filters, update appliedFilters to include dateFilter, startDate, endDate, and last24Hours
    setAppliedFilters({ ...filterValues });
  };

  const handleOpenDetail = (job, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    navigate(`/${firstSegment}/live-job-feed/job-detail-page/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidiates = (job) => {
    navigate(`/${firstSegment}/live-job-feed/job-candidates-page/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };

  const fetchCategories = async (path, search, loading, id, filters = {}) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (!id) {
      id = findId || localStorage.getItem("source_id");
      console.log(id, "ididididid");
    }
    const response = await _get_job_feed_list_blog_api(
      id,
      search,
      path,
      filters
    );
    for (let i = 0; i < response.jobs.length; i++) {
      for (let j = 0; j < response.jobs[i].job_applicants.length; j++) {
        if (
          userInfo?.user_id?._id === response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }
    console.log(response, "responseresponseresponse jobs");

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);
      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }
      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, searchTerm, true, findId);
  };

  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(searchInputValue);
    }, 1000);
    return () => clearTimeout(handler);
  }, [searchInputValue]);

  // useEffect for API call (already present)
  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchTerm, false, findId, filterValues);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm]);

  useEffect(() => {
    fetchCategories(load_more_path, searchTerm, false, findId);
  }, [isRefresh]);
  console.log(findId, "findIdfindIdfindIdfindId");

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: "",
        active: true,
      },
    ]);
  }, []);
  console.log(categories, "categoriescategoriescategories");
  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval = null;
    let resumeTimeout = null;
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    );

    const resetScrollToTop = () => {
      // Pause at the bottom for 3 seconds before scrolling back to top
      setIsScrolling(true);

      setTimeout(() => {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          // Temporarily disable smooth scrolling for the reset
          scrollContainer.style.scrollBehavior = "auto";
          scrollContainer.scrollTop = 0;

          // Trigger reflow
          void scrollContainer.offsetHeight;

          // Re-enable smooth scrolling
          setTimeout(() => {
            scrollContainer.style.scrollBehavior = "smooth";
            setIsScrolling(false);
          }, 100);
        });
      }, 3000); // 3 second delay at the bottom before scrolling back to top
    };

    const startScroll = () => {
      scrollInterval = setInterval(() => {
        if (isHovered || isScrolling) return;

        const atBottom =
          Math.ceil(scrollContainer.scrollTop + scrollContainer.clientHeight) >=
          scrollContainer.scrollHeight - 5;

        if (atBottom && categories.length > 0) {
          resetScrollToTop(); // Wait 3 seconds then reset to top
        } else {
          // Smoother scrolling for mobile devices
          if (isMobileDevice) {
            scrollContainer.scrollBy({
              top: 1,
              behavior: "smooth",
            });
          } else {
            scrollContainer.scrollTop += 1;
          }
        }
      }, 30);
    };

    let lastTouchTime = 0;

    const stopScrollTemporarily = () => {
      const now = Date.now();
      if (now - lastTouchTime < 300) return; // debounce
      lastTouchTime = now;

      setIsScrolling(true);
      clearInterval(scrollInterval);
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(() => {
        setIsScrolling(false);
        startScroll();
      }, 2000);
    };

    // Set initial smooth scrolling behavior
    scrollContainer.style.scrollBehavior = "smooth";
    startScroll();

    scrollContainer.addEventListener("touchstart", stopScrollTemporarily, {
      passive: true, // Changed to true for better performance
    });
    scrollContainer.addEventListener("touchend", stopScrollTemporarily, {
      passive: true, // Changed to true for better performance
    });

    return () => {
      clearInterval(scrollInterval);
      clearTimeout(resumeTimeout);
      scrollContainer.removeEventListener("touchstart", stopScrollTemporarily);
      scrollContainer.removeEventListener("touchend", stopScrollTemporarily);
    };
  }, [isHovered, categories, isScrolling]);

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick(row) {
        handleOpenEditJob(row);
      },
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
    },
  ];

  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);

  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  // const handleOpenDetail = (job) => {
  //   setSelectedJob(job);
  //   setOpenDetail(true);
  // };

  let arr = [12, 34, 67, 12, 88, 9, 0];
  let max = arr[0];
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      max = arr[i];
    }
  }

  console.log("Largest number:", max);

  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handlePersonalJob = () => {
    console.log("callled");
    navigate(`/${firstSegment}/live-job-feed/personal-jobs`);
  };
  const handleNavigateAppliedJobs = () => {
    console.log("callled");
    navigate(`/${firstSegment}/live-job-feed/applied-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);
    console.log("Deleting Member ID:", id); // Debugging ke liye

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  const handleDelete = (row) => {
    console.log(row._id, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };

  // Filter drawer state

  // Filter handlers
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    // If changing dateFilter, reset last24Hours and dates accordingly
    if (name === "dateFilter") {
      setFilterValues((prev) => ({
        ...prev,
        dateFilter: value,
        last24Hours: value === "last24hours",
        startDate: value === "custom" ? prev.startDate : "",
        endDate: value === "custom" ? prev.endDate : "",
      }));
    } else {
      setFilterValues((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleFilterDrawerOpen = () => setFilterDrawerOpen(true);
  const handleFilterDrawerClose = () => setFilterDrawerOpen(false);
  const handleFilterClear = () => {
    setFilterValues({
      clientName: "",
      location: "",
      education: "",
      jobType: "",
      experience: "",
      minSalary: "",
      maxSalary: "",
      frequency: "",
      // ...other fields
    });
    setAppliedFilters({
      clientName: null,
      experience: null,
      jobType: null,
      frequency: null,
      salary: null,
      education: null,
      minSalary: null,
      maxSalary: null,
    });
    setFilterDrawerOpen(false);
    fetchCategories(load_more_path, searchTerm, false, findId, {});
  };

  // Remove a specific filter chip
  const handleRemoveFilterChip = (key) => {
    const updatedFilterValues = { ...filterValues };
    const updatedAppliedFilters = { ...appliedFilters };

    if (key === "minSalary") {
      updatedFilterValues.minSalary = "";
      updatedAppliedFilters.minSalary = null;
    } else if (key === "maxSalary") {
      updatedFilterValues.maxSalary = "";
      updatedAppliedFilters.maxSalary = null;
    } else if (key === "dateFilter") {
      updatedFilterValues.dateFilter = "";
      updatedFilterValues.startDate = "";
      updatedFilterValues.endDate = "";
      updatedFilterValues.last24Hours = false;
      updatedAppliedFilters.dateFilter = null;
      updatedAppliedFilters.startDate = null;
      updatedAppliedFilters.endDate = null;
      updatedAppliedFilters.last24Hours = false;
    } else {
      updatedFilterValues[key] = "";
      updatedAppliedFilters[key] = null;
    }

    setFilterValues(updatedFilterValues);
    setAppliedFilters(updatedAppliedFilters);

    // Create filters object for API call
    const filters = {
      clientName: updatedFilterValues.clientName,
      location: updatedFilterValues.location,
      education: updatedFilterValues.education,
      jobType: updatedFilterValues.jobType,
      experience: updatedFilterValues.experience,
      minSalary: updatedFilterValues.minSalary,
      maxSalary: updatedFilterValues.maxSalary,
      frequencySalary: updatedFilterValues.frequency,
      // created_for: findId,
    };

    // Remove empty values
    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey] || filters[filterKey] === "") {
        delete filters[filterKey];
      }
    });

    // Make API call with updated filters
    fetchCategories(load_more_path, searchTerm, false, findId, filters);
  };

  // Helper to get filter label
  const filterLabels = {
    clientName: "Company Name",
    experience: "Experience",
    jobType: "Job Type",
    location: "Location",
    education: "Education",
    frequency: "Frequency Salary",
    // Remove minSalary and maxSalary from here, handle below
  };

  // Helper to get filter value display (can be customized)
  const getFilterValueDisplay = (key, value) => {
    if (key === "experience") return show_des_data(value);
    if (key === "education") return formatEducationRequired(value);
    return value;
  };

  // Helper to render filter chips, combining minSalary/maxSalary into one
  const renderFilterChips = () => {
    const chips = [];
    // Date filter chip logic
    let last24HoursChipAdded = false;
    if (appliedFilters.dateFilter === "last24hours") {
      chips.push(
        <Chip
          key="last24hours"
          label="Last 24 hours"
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
      last24HoursChipAdded = true;
    }
    // Custom date range chip logic
    let customDateChipAdded = false;
    if (
      appliedFilters.dateFilter === "custom" &&
      appliedFilters.startDate &&
      appliedFilters.endDate
    ) {
      chips.push(
        <Chip
          key="customDateRange"
          label={`Date: ${appliedFilters.startDate} to ${appliedFilters.endDate}`}
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
      customDateChipAdded = true;
    }
    // Min Salary chip
    if (appliedFilters.minSalary) {
      chips.push(
        <Chip
          key="minSalary"
          label={`Min Salary: €${appliedFilters.minSalary}`}
          onDelete={() => handleRemoveFilterChip("minSalary")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    // Max Salary chip
    if (appliedFilters.maxSalary) {
      chips.push(
        <Chip
          key="maxSalary"
          label={`Max Salary: €${appliedFilters.maxSalary}`}
          onDelete={() => handleRemoveFilterChip("maxSalary")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    // Other chips
    Object.entries(appliedFilters)
      .filter(
        ([key, value]) =>
          value &&
          key !== "minSalary" &&
          key !== "maxSalary" &&
          key !== "dateFilter" &&
          // Prevent duplicate custom date chip and never show startDate/endDate as separate chips if custom date chip is added
          !(
            customDateChipAdded &&
            (key === "startDate" || key === "endDate")
          ) &&
          // Prevent last24Hours chip from showing as a separate chip
          !(last24HoursChipAdded && key === "last24Hours")
      )
      .forEach(([key, value]) => {
        chips.push(
          <Chip
            key={key}
            label={`${filterLabels[key] || key}: ${getFilterValueDisplay(
              key,
              value
            )}`}
            onDelete={() => handleRemoveFilterChip(key)}
            sx={{ background: "#c0cdfa", color: "#000" }}
          />
        );
      });
    // Date range chip for other date filters (not custom)
    if (
      !customDateChipAdded &&
      ["last3days", "last7days", "last14days"].includes(
        appliedFilters.dateFilter
      )
    ) {
      // Show a chip for these date filters
      let label = "";
      if (appliedFilters.dateFilter === "last3days") label = "Last 3 days";
      if (appliedFilters.dateFilter === "last7days") label = "Last 7 days";
      if (appliedFilters.dateFilter === "last14days") label = "Last 14 days";
      chips.push(
        <Chip
          key={appliedFilters.dateFilter}
          label={label}
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    return chips;
  };

  return (
    <>
      <PostJobModal
        refreshlist={fetchCategories}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        jobData={selectedJob} // Pass selected job data when editing
        sourceId={sourceId}
      />

      <PostJobDetail
        cv={cv}
        open={openDetail}
        setCv={setCv}
        job={selectedJob}
        handleClose={handleCloseDetail}
      />
      {isMobile ? (
        <div className="container-fluid px-2">
          <div className="row">
            <div className="mt-3 mb-4 col-12">
              <div className="card-body mt-1 main-heading-live-jobs jobs-live-main">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
                  <h2 className="ml-md-4 mb-2 mb-md-0">Live Jobs Feed</h2>
                  <div className="d-flex flex-column flex-sm-row gap-2 w-100 w-md-auto">
                    <Box display="flex" gap={1} width="100%">
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Search by Job Title, Description"
                        value={searchInputValue}
                        onChange={handleInputChange}
                        sx={{ minWidth: 320, flexGrow: 1 }}
                        InputProps={{
                          sx: {
                            "& input::placeholder": {
                              color: "#b0b0b0",
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </Box>
                    {/* Filter Button */}
                    <button
                      className="small-button-contain-job-live w-100 w-sm-auto"
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                      onClick={handleFilterDrawerOpen}
                      type="button"
                    >
                      <FilterListIcon
                        style={{ fontSize: 20, marginRight: 4 }}
                      />
                      Filter
                    </button>
                    {userInfo.type === 2 && (
                      <>
                        <button
                          className="small-button-contain-job-live w-100 w-sm-auto"
                          onClick={handlePersonalJob}
                        >
                          My Job Posts
                        </button>
                        <button
                          className="small-button-contain-job-live w-100 w-sm-auto"
                          onClick={handleOpen}
                        >
                          <PostAddOutlinedIcon className="post-add-icon" />
                          Post Job
                        </button>
                      </>
                    )}
                    {userInfo?.type === 1 && (
                      <button
                        className="small-button-contain-job-live"
                        onClick={handleNavigateAppliedJobs}
                      >
                        <CheckCircleOutlineIcon
                          style={{
                            fontSize: "18px",
                            color: "#fff",
                          }}
                        />{" "}
                        Applied Jobs
                      </button>
                    )}
                  </div>
                </div>
                {/* Filter Chips Section (Mobile) */}
                <Box mb={2} display="flex" flexWrap="wrap" gap={1}>
                  {renderFilterChips()}
                  {Object.values(appliedFilters).some(Boolean) && (
                    <Chip
                      label="Clear All"
                      onDelete={handleFilterClear}
                      color="error"
                      sx={{
                        backgroundColor: "rgba(192, 204, 250, 0.39)",
                        color: "#000",
                      }}
                    />
                  )}
                </Box>
                <div
                  className=" px-3"
                  ref={scrollRef}
                  style={{
                    height: "1000px",
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                    paddingBottom: "50px",
                  }}
                >
                  <Box className="row" mt={4}>
                    {categories.length > 0 ? (
                      categories.map((job, index) => (
                        <div
                          key={index}
                          className="col-12 col-md-6 col-lg-4 mb-3 job-card-hover"
                        >
                          <Card
                            onClick={(e) => handleOpenDetail(job, e)}
                            variant="outlined"
                            className="mui-card h-100"
                            sx={{
                              borderRadius: 2,
                              mb: 2,
                              p: 2,
                              border: "2px solid transparent !important",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                border: "2px solid #DAA520 !important",
                              },
                            }}
                          >
                            <CardContent className="card-content-mui">
                              <Box
                                display="flex"
                                flexDirection={{ xs: "column", sm: "row" }}
                                justifyContent="space-between"
                                alignItems={{ xs: "flex-start", sm: "center" }}
                                gap={2}
                              >
                                {/* Profile and Job Title */}
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={2}
                                  width="100%"
                                >
                                  <Avatar
                                    src={
                                      s3baseUri +
                                      job?.creater_info?.profile_image
                                    }
                                    alt=""
                                    style={{
                                      width: 50,
                                      height: 50,
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                    onClick={(e) => handleOpenDetail(job, e)}
                                  />
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      fontWeight="bold"
                                      sx={{ cursor: "pointer" }}
                                      onClick={(e) => handleOpenDetail(job, e)}
                                    >
                                      {job.jobTitle}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="textSecondary"
                                      sx={{ cursor: "pointer" }}
                                      onClick={(e) => handleOpenDetail(job, e)}
                                    >
                                      {job.location} •{" "}
                                      <span
                                        style={{
                                          color: "navy",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment(job.createdAt).fromNow()}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Icons on right */}
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  flexWrap="wrap"
                                >
                                  {job.created_by ===
                                    userInfo?.user_id?._id && (
                                    <Chip
                                      label="My Job"
                                      variant="outlined"
                                      color="primary"
                                    />
                                  )}
                                  {userInfo.type === 1 && (
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                        handleBookmarkToggle(job._id);
                                      }}
                                      sx={{
                                        paddingRight: "3px !important",
                                        paddingTop: "2px !important",
                                        paddingBottom: "0px !important",
                                      }}
                                    >
                                      {bookmarkedJobs[job._id] ? (
                                        <BookmarkIcon
                                          sx={{
                                            color: "#000080",
                                            padding: "0px !important",
                                          }}
                                        />
                                      ) : (
                                        <BookmarkBorderIcon
                                          sx={{
                                            padding: "0px !important",
                                          }}
                                        />
                                      )}
                                    </IconButton>
                                  )}

                                  {job.created_by ===
                                    userInfo?.user_id?._id && (
                                    <div onClick={(e) => e.stopPropagation()}>
                                      {" "}
                                      {/* ⚠️ Prevent Card's onClick */}
                                      <CustomPopoverSection
                                        menu={MENU_OPTIONS}
                                        data={job}
                                      />
                                    </div>
                                  )}
                                </Box>
                              </Box>

                              {/* Tags and Chips */}
                              <Box
                                display="flex"
                                gap={1}
                                flexWrap="wrap"
                                my={2}
                              >
                                <Chip label={job.jobType} variant="outlined" />
                                <Chip
                                  label={show_des_data(job.experienceRequired)}
                                  variant="outlined"
                                />
                                <Chip
                                  label={formatEducationRequired(
                                    job.educationRequired
                                  )}
                                  variant="outlined"
                                />
                              </Box>

                              {/* Description */}
                              <Typography
                                variant="body1"
                                sx={{
                                  mt: 2,
                                  fontSize: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleOpenDetail(job, e)}
                              >
                                <span
                                  className="svg-icon-editor"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      job.description.length > 300
                                        ? `${job.description.slice(0, 300)}...`
                                        : job.description,
                                  }}
                                />
                                {job.description.length > 300 && (
                                  <span
                                    style={{
                                      color: "navy",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Read More
                                  </span>
                                )}
                              </Typography>

                              {/* Salary and Apply */}
                              <Box
                                display="flex"
                                flexDirection={{ xs: "column", sm: "row" }}
                                justifyContent="space-between"
                                alignItems={{ xs: "flex-start", sm: "center" }}
                                mt={2}
                                gap={2}
                              >
                                <Box display="flex" gap={1} flexWrap="wrap">
                                  {job.salaryType === "range" ? (
                                    <>
                                      <Chip
                                        label={`Min Salary: €${job.minSalary}/${
                                          job.frequencySalary
                                            ? job.frequencySalary.toLowerCase()
                                            : ""
                                        }`}
                                        variant="outlined"
                                      />
                                      <Chip
                                        label={`Max Salary: €${job.maxSalary}/${
                                          job.frequencySalary
                                            ? job.frequencySalary.toLowerCase()
                                            : ""
                                        }`}
                                        variant="outlined"
                                      />
                                    </>
                                  ) : job.salaryType === "fixed" ? (
                                    <Chip
                                      label={`Fixed Salary: €${job.salary}/${
                                        job.frequencySalary
                                          ? job.frequencySalary.toLowerCase()
                                          : ""
                                      }`}
                                      variant="outlined"
                                    />
                                  ) : null}
                                </Box>

                                <Box display="flex" gap={2} flexWrap="wrap">
                                  {job.created_by === userInfo?.user_id?._id &&
                                    userInfo?.type === 2 && (
                                      <div className="position-relative">
                                        <div
                                          className="badge position-absolute"
                                          style={{
                                            top: "-7px",
                                            right: "-6px",
                                            backgroundColor: "#FF0000",
                                            color: "#fff",
                                            padding: "2px 6px",
                                            borderRadius: "12px",
                                            minWidth: "20px",
                                            textAlign: "center",
                                            fontSize: "12px",
                                            lineHeight: "1.2",
                                          }}
                                        >
                                          {job?.job_applicants?.length || 0}
                                        </div>
                                        <button
                                          className="small-button-contain-job-candidates"
                                          onClick={(e) => {
                                            e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                            handleCandidiates(job);
                                          }}
                                        >
                                          View Candidates
                                        </button>
                                      </div>
                                    )}
                                  {userInfo.user_id._id !== job.created_by ? (
                                    job.created_by_me ? (
                                      userInfo?.type === 1 && (
                                        <span>
                                          <CheckCircleOutlineIcon
                                            style={{
                                              color: "#4CAF50",
                                              marginRight: "2px",
                                            }}
                                          />
                                          Applied
                                        </span>
                                      )
                                    ) : (
                                      userInfo.type === 1 && (
                                        <button
                                          className="small-button-contain-job"
                                          onClick={(e) =>
                                            handleOpenDetail(job, e)
                                          }
                                        >
                                          Apply Job
                                        </button>
                                      )
                                    )
                                  ) : (
                                    <button
                                      className="small-button-contain-job"
                                      onClick={(e) => handleOpenDetail(job, e)}
                                    >
                                      View Detail
                                    </button>
                                  )}
                                </Box>
                              </Box>
                            </CardContent>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>
                        <RecordNotFound title="No jobs" />
                      </div>
                    )}

                    {totalPages >= pageNumber && (
                      <div className="col-12 text-center mt-3">
                        <span
                          ref={lastBookElementRef}
                          className="mt-3"
                          onClick={loadMoreData}
                          id="load-more-feed"
                        >
                          {isLoadingMore ? (
                            <CircularProgress color="primary" size="1.5rem" />
                          ) : (
                            "Load More"
                          )}
                        </span>
                      </div>
                    )}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className=" mb-4">
              <div className="card-body  main-heading-live-jobs jobs-live-main">
                <div className="d-flex justify-content-between mb-3">
                  <h2 className="ml-4">Live Jobs Feed </h2>
                  <div className="d-flex gap-2">
                    <Box display="flex" gap={1}>
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Search by Job Title, Description"
                        value={searchInputValue}
                        onChange={handleInputChange}
                        sx={{ minWidth: 280, flexGrow: 1 }}
                        InputProps={{
                          sx: {
                            "& input::placeholder": {
                              color: "#b0b0b0",
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </Box>
                    {/* Filter Button */}
                    <button
                      className="small-button-contain-job-live"
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                      onClick={handleFilterDrawerOpen}
                      type="button"
                    >
                      <FilterListIcon
                        style={{ fontSize: 20, marginRight: 4 }}
                      />
                      Filter
                    </button>
                    {userInfo.type === 2 && (
                      <>
                        <button
                          className="small-button-contain-job-live"
                          onClick={handlePersonalJob}
                        >
                          My Job Posts
                        </button>
                        <button
                          className="small-button-contain-job-live"
                          onClick={handleOpen}
                        >
                          <PostAddOutlinedIcon className="post-add-icon" />
                          Post Job
                        </button>
                      </>
                    )}
                    {userInfo?.type === 1 && (
                      <button
                        className="small-button-contain-job-live"
                        onClick={handleNavigateAppliedJobs}
                      >
                        <CheckCircleOutlineIcon
                          style={{
                            fontSize: "18px",
                            color: "#fff",
                          }}
                        />{" "}
                        Applied Jobs
                      </button>
                    )}
                  </div>
                </div>
                {/* Filter Chips Section (Desktop) */}
                <Box mb={2} display="flex" flexWrap="wrap" gap={1}>
                  {renderFilterChips()}
                  {Object.values(appliedFilters).some(Boolean) && (
                    <Chip
                      label="Clear All"
                      onDelete={handleFilterClear}
                      color="error"
                      sx={{
                        backgroundColor: "rgba(192, 204, 250, 0.39)",
                        color: "#000",
                      }}
                    />
                  )}
                </Box>
                {loading ? (
                  <SkeletonJObs />
                ) : (
                  <div
                    className=" px-3"
                    ref={scrollRef}
                    style={{
                      height: "1000px",
                      overflowY: "auto",
                      WebkitOverflowScrolling: "touch",
                      paddingBottom: "50px",
                    }}
                  >
                    <Box className="row " mt={4}>
                      {categories.length > 0 ? (
                        categories.map((job, index) => (
                          <div key={index} className="col-12 mb-3">
                            {" "}
                            {/* Full width card */}
                            <Card
                              onClick={(e) => handleOpenDetail(job, e)}
                              variant="outlined"
                              className="mui-card"
                              sx={{
                                borderRadius: 2,
                                mb: 2,
                                p: 2,
                                border: "2px solid transparent !important",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  border: "2px solid #DAA520 !important",
                                },
                                cursor: "pointer",
                              }}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              <CardContent className="card-content-mui">
                                {/* Header */}
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <Box
                                      onClick={(e) => handleOpenDetail(job, e)}
                                      sx={{
                                        width: 40,
                                        height: 40,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Avatar
                                        src={
                                          s3baseUri +
                                          job?.creater_info?.profile_image
                                        }
                                        alt=""
                                        style={{
                                          width: 50,
                                          height: 50,
                                          borderRadius: "50%", // Optional: makes it circular like a typical profile icon
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>

                                    <Box sx={{ ms: 2 }}>
                                      <div className="d-flex">
                                        <Typography
                                          onClick={(e) =>
                                            handleOpenDetail(job, e)
                                          }
                                          variant="h6"
                                          className="ms-3"
                                          fontWeight="bold"
                                          sx={{ cursor: "pointer" }}
                                        >
                                          {job.jobTitle}{" "}
                                        </Typography>
                                      </div>

                                      <Typography
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                        variant="body2"
                                        className="ms-3"
                                        color="textSecondary"
                                      >
                                        {job.location} •{" "}
                                        <span
                                          style={{
                                            color: "navy",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {moment(job.createdAt).fromNow()}
                                        </span>
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <div className="d-flex align-items-center responsive-chip-icons">
                                    {job.created_by ===
                                      userInfo?.user_id?._id && (
                                      <Chip
                                        className="mui-chip"
                                        label="My Job"
                                        variant="outlined"
                                        color="primary"
                                      />
                                    )}
                                    {userInfo?.type === 1 && (
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation(); // This stops the event from bubbling up
                                          handleBookmarkToggle(job._id);
                                        }}
                                        sx={{
                                          paddingRight: "3px !important",
                                          paddingTop: "2px !important",
                                          paddingBottom: "0px !important",
                                        }}
                                      >
                                        {bookmarkedJobs[job._id] ? (
                                          <BookmarkIcon
                                            className="responsive-icon"
                                            sx={{
                                              color: "#000080",
                                              padding: "0px !important",
                                            }}
                                          />
                                        ) : (
                                          <BookmarkBorderIcon
                                            className="responsive-icon"
                                            style={{
                                              padding: "0px !important",
                                            }}
                                          />
                                        )}
                                      </IconButton>
                                    )}

                                    {job.created_by ===
                                      userInfo?.user_id?._id && (
                                      <div onClick={(e) => e.stopPropagation()}>
                                        <CustomPopoverSection
                                          menu={MENU_OPTIONS}
                                          data={job}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Box>

                                {/* Job Tags */}
                                <Box
                                  display="flex"
                                  gap={1}
                                  my={2}
                                  justifyContent="space-between"
                                  onClick={(e) => handleOpenDetail(job, e)}
                                >
                                  {/* Left-aligned chips */}
                                  <Box display="flex" gap={1}>
                                    <Chip
                                      className="mui-chip"
                                      label={job.jobType}
                                      variant="outlined"
                                    />
                                    <Chip
                                      className="mui-chip"
                                      // label={job.experienceRequired}
                                      label={show_des_data(
                                        job?.experienceRequired
                                      )}
                                      variant="outlined"
                                    />
                                    <Chip
                                      className="mui-chip"
                                      // label={job.experienceRequired}
                                      label={formatEducationRequired(
                                        job?.educationRequired
                                      )}
                                      variant="outlined"
                                    />
                                  </Box>

                                  {/* Right-aligned "Personal Job" chip (only if applicable) */}
                                </Box>

                                <Typography
                                  variant="body1"
                                  sx={{
                                    mt: 2,
                                    fontSize: "15px",
                                    cursor: "pointer",
                                    display: "inline",
                                    mb: 0,
                                  }}
                                  onClick={(e) => handleOpenDetail(job, e)}
                                >
                                  <span
                                    className="svg-icon-editor"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        job.description.length > 300
                                          ? `${job.description.slice(
                                              0,
                                              300
                                            )}...`
                                          : job.description,
                                    }}
                                  />

                                  {job.description.length > 300 && (
                                    <span
                                      style={{
                                        color: "navy",
                                        cursor: "pointer",
                                        textDecoration: "underline", // Added this line
                                      }}
                                      onClick={(e) => handleOpenDetail(job, e)}
                                    >
                                      Read More
                                    </span>
                                  )}
                                </Typography>

                                {/* Salary & Apply */}
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  mt={2}
                                >
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    gap={1}
                                  >
                                    {job.salaryType === "range" ? (
                                      <>
                                        <Chip
                                          variant="outlined"
                                          className="mui-chip"
                                          label={`Min Salary: €${
                                            job.minSalary
                                          }/${
                                            job.frequencySalary
                                              ? job.frequencySalary.toLowerCase()
                                              : ""
                                          }`}
                                          onClick={(e) =>
                                            handleOpenDetail(job, e)
                                          }
                                          sx={{ cursor: "pointer" }}
                                        />
                                        <Chip
                                          className="mui-chip"
                                          variant="outlined"
                                          label={`Max Salary: €${
                                            job.maxSalary
                                          }/${
                                            job.frequencySalary
                                              ? job.frequencySalary.toLowerCase()
                                              : ""
                                          }`}
                                          onClick={() => handleOpenDetail(job)}
                                        />
                                      </>
                                    ) : job.salaryType === "fixed" ? (
                                      <Chip
                                        className="mui-chip"
                                        variant="outlined"
                                        label={`Fixed Salary: €${job.salary}/${
                                          job.frequencySalary
                                            ? job.frequencySalary.toLowerCase()
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                      />
                                    ) : null}
                                  </Box>

                                  <div className="d-flex align-items-center">
                                    {job.created_by ===
                                      userInfo?.user_id?._id &&
                                      userInfo?.type === 2 && (
                                        <div className="position-relative">
                                          <div
                                            className="badge position-absolute"
                                            style={{
                                              top: "-7px",
                                              right: "2px",
                                              backgroundColor: "#FF0000",
                                              color: "#fff",
                                              padding: "2px 6px",
                                              borderRadius: "12px",
                                              minWidth: "20px",
                                              textAlign: "center",
                                              fontSize: "12px",
                                              lineHeight: "1.2",
                                            }}
                                          >
                                            {job?.job_applicants?.length || 0}
                                          </div>
                                          <button
                                            style={{ width: "auto !important" }}
                                            onClick={(e) => {
                                              e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                              handleCandidiates(job);
                                            }}
                                            className="small-button-contain-job-candidates me-2"
                                          >
                                            View Candidates
                                          </button>
                                        </div>
                                      )}

                                    {userInfo.user_id._id !== job.created_by &&
                                      (job.created_by_me != null &&
                                      job.created_by_me !== undefined &&
                                      job.created_by_me === true
                                        ? userInfo.type === 1 && (
                                            <span className="me-2 mt-1">
                                              <CheckCircleOutlineIcon
                                                style={{
                                                  color: "#4CAF50",
                                                  marginRight: "2px",
                                                }}
                                              />
                                              Applied
                                            </span>
                                          )
                                        : userInfo?.type === 1 && (
                                            <button
                                              onClick={(e) =>
                                                handleOpenDetail(job, e)
                                              }
                                              className="small-button-contain-job"
                                            >
                                              Apply Job
                                            </button>
                                          ))}

                                    {userInfo.user_id._id ===
                                      job.created_by && (
                                      <button
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                        className="small-button-contain-job"
                                      >
                                        View Detail
                                      </button>
                                    )}
                                  </div>
                                </Box>
                              </CardContent>
                            </Card>
                          </div>
                        ))
                      ) : (
                        <div>
                          <RecordNotFound title="No jobs" />
                        </div>
                      )}
                      {totalPages >= pageNumber ? (
                        <div className="col-12 text-center mt-3">
                          <span
                            ref={lastBookElementRef}
                            className="mt-3"
                            onClick={loadMoreData}
                            id="load-more-feed"
                          >
                            {isLoadingMore ? (
                              <CircularProgress color="primary" size="1.5rem" />
                            ) : (
                              "Load More"
                            )}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </Box>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomDrawer
        isOpenDrawer={filterDrawerOpen}
        onCloseDrawer={handleFilterDrawerClose}
        pageTitle="Filter Jobs"
        componentToPassDown={
          <JobsFilter
            onCloseDrawer={handleFilterDrawerClose}
            selectedObject={null}
            refreshList={fetchCategories}
            memberList={categories}
            applyFilters={applyFilters}
            handleFilterChange={handleFilterChange}
            filterValues={filterValues}
            handleFilterClear={handleFilterClear}
          />
        }
      />

      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this job?"}
        in
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </>
  );
}
